import { Loader } from "@circle-react-shared/uikit/Loader";
import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { Button as CompassButton } from "@circleco/compass/components/Button";

import { t } from "@/i18n-js/instance";

export const LoggedOutPreviewActions = () => {
  const { currentCommunity, isLoading } = usePunditUserContext();

  // Match V3 builder preview (LoggedOutActions), not session-dependent
  // show_signup_link (false for logged-in admins).
  const hasPrivateSignUpUrl = !!currentCommunity?.private_sign_up_url;
  const isPrivateCommunityOrHasPrivateSignUpUrl =
    currentCommunity?.is_private || hasPrivateSignUpUrl;
  const isPublicCommunityButAllowsSignups =
    !currentCommunity?.is_private &&
    !!currentCommunity?.allow_signups_to_public_community;
  const hasSignUpLink =
    isPrivateCommunityOrHasPrivateSignUpUrl ||
    isPublicCommunityButAllowsSignups;

  const signUpLabel = hasPrivateSignUpUrl
    ? currentCommunity?.private_sign_up_label
    : t("join");

  if (isLoading) {
    return <Loader className="flex !py-0" />;
  }

  return (
    <div className="hidden items-center justify-end gap-2.5 md:flex">
      <CompassButton variant="outline" size="md">
        {t("log_in")}
      </CompassButton>
      {hasSignUpLink && (
        <CompassButton variant="branded" size="md">
          {signUpLabel}
        </CompassButton>
      )}
    </div>
  );
};
